import React from "react";
import { View, StyleSheet } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";

function NtBusinessPBXSection(props) {
  return (
    <NtMarketingSectionContainer
      style={styles.container}
      backgroundImage={require("../../../assets/images/marketing/847ef15685cc5662ce90bfa566d609540eac31c4.jpg")}
    >
      <View
        style={{ flex: 1, alignItems: "flex-end", justifyContent: "center" }}
      >
        <View style={{ maxWidth: 300 }}>
          <NtSectionTitle style={{ textAlign: "left" }}>
            WHAT IS A PBX?
          </NtSectionTitle>
          <NtSectionDescription style={{ marginTop: 10 }}>
            A PBX is a telephone system for businesses, both large and small. It
            allows companies to control all incoming/outgoing calls with one
            system, the PBX. A PBX system is highly customizable, and it gives
            companies full control over the phone experience customers receive
            when they call and borderless company communications for employees.
          </NtSectionDescription>
        </View>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    height: 600,
  },
});

export default NtBusinessPBXSection;
